module.exports = __webpack_public_path__ + "media/components/assets/icons/star_empty-261ea593b5588ec1efdae1fb15d12028.svg";